import { listSubject, listYear } from '@/api/config.js'
import Cache from '@/utils/cache.js'

export default {
  namespace: true,
  state: {
    years: {
      INTERNATIONAL_HOSPITAL: [],
      UNIVERSITY: [],
      HOSPITAL: [],
      HIGH_LIGHT: [],
      UNIVERSITY_ASTEM: [],
      HOSPITAL_ASTEM: [],
      HOSPITAL_SUBJECT_ASTEM: []
    },
    currentYear: {
      INTERNATIONAL_HOSPITAL: '',
      UNIVERSITY: '',
      HOSPITAL: '',
      HIGH_LIGHT: '',
      UNIVERSITY_ASTEM: '',
      HOSPITAL_ASTEM: '',
      HOSPITAL_SUBJECT_ASTEM: ''
    },
    subjects: []
  },
  getters: {
    currentYear(state) {
      return state.currentYear
    },
    years(state) {
      return state.years
    },
    subjects(state) {
      return state.subjects || []
    }
  },
  mutations: {
    setYears(state, years) {
      years.forEach((item) => {
        item.year.reverse()
        state.currentYear[item.type] = item.year[0]
        state.years[item.type] = item.year
        // Cache.set(`top100_${item.type}_year`, state.years[item.type])
      })
    },
    setSubjects(state, subjects) {
      state.subjects = subjects
      Cache.set('top100_subject', subjects)
    }
  },
  actions: {
    init({ commit, state }) {
      return Promise.all([listSubject(), listYear()]).then((res) => {
        const [resSubjects, resYear] = res
        const subjects = resSubjects && resSubjects.length ? resSubjects : []
        const years = resYear && resYear.length ? resYear : []

        // TODO:
        years.push({
          type: 'INTERNATIONAl',
          year: ['2018', '2019', '2020', '2021']
        })

        commit(
          'setSubjects',
          subjects.map((item) => {
            const { name, subjectList } = item
            return {
              value: name,
              label: name,
              children: subjectList.map(({ code, name }) => {
                return { label: name, value: code }
              })
            }
          })
        )
        commit('setYears', years)
      })
    }
  }
}
